// Import package components
import { useContext, useEffect, useState, useRef } from "react";
import UIkit from "uikit";
import { AppContexts } from "../../../providers";

const macrosValues = [
  { value: "[CompanyName]", label: "Company Name" },
  { value: "[FirstName]", label: "Guest's first name" },
  { value: "[Email]", label: "Guest Email" },
  { value: "[LastName]", label: "Guest's last name" },
  { value: "[PropertyId]", label: "Property Id" },
  { value: "[CheckIn]", label: "Check-in date" },
  { value: "[CheckOut]", label: "Check-out date" },
  { value: "[PhoneNumber]", label: "Guest Phone Number" },
  { value: "[ReservationId]", label: "Reservation Number" },
  { value: "[PropertyAddress]", label: "Property address" },
  { value: "[DoorCode]", label: "Reservation's door code" },
  { value: "[PropertyGuideLink]", label: "Link to home guide" },
  { value: "[DestinationGuideLink]", label: "Link to area guide" },
  { value: "[FiveStarLink]", label: "Five-star review link" },
  { value: "[GuestCheckIn]", label: "Link to check-in" },
  { value: "[GuestCheckOut]", label: "Link to check-out" },
  { value: "[EarlyCheckIn]", label: "Link to request early check-in" },
  { value: "[LateCheckOut]", label: "Link to request late check-out" },
];
macrosValues.sort((a, b) => a.value > b.value ? 1 : -1);

const MacrosReservationKeys = ({ onMacroClick }) => {
  let { allSurveys, getSurveyList } = useContext(AppContexts.SurveysContext);
  let { settings, get } = useContext(AppContexts.SettingsContext);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    getSurveyList();
    get(["custom_macros"]);

    const dropdownElement = document.getElementById("macros-reservation");
    if (dropdownElement) {
      dropdownElement.addEventListener("beforehide", handleDropdownClose);
    }
    return () => {
      if (dropdownElement) {
        dropdownElement.removeEventListener("beforehide", handleDropdownClose);
      }
    };
  }, []);

  const handleDropdownClose = () => {
    const dropdownElement = document.getElementById("macros-reservation");
    if (dropdownElement) {
      dropdownElement.scrollTop = 0;
    }
  };

  const handleMacroClick = (macros) => {
    if (onMacroClick) onMacroClick(macros.value);
    document.querySelectorAll('#macros-reservation').forEach(el => {
      window.UIkit.dropdown(el).hide();
    });
  }

  return (
    <>
      <div id="macros-reservation" data-uk-dropdown="mode: click">
        <ul className="uk-nav uk-dropdown-nav tags-selector">
          <div className="uk-form-label uk-margin-top uk-margin-tiny-bottom uk-margin-small-left">
            Booking Macros
          </div>
          {macrosValues.map((macros, index) => (
            <li
              key={`macros_${index}`}
              className="messages-li"
              uk-tooltip="Click to Insert Macro"
              onClick={() => handleMacroClick(macros)}
              style={{ cursor: "pointer" }}
            >
              <span className="macro-value">{macros.value}</span>{" "}
              <span>{macros.label}</span>
            </li>
          ))}
          <div className="uk-form-label uk-margin-top uk-margin-tiny-bottom uk-margin-small-left">
            Property Macros
          </div>
          {settings.custom_macros?.map((macros, index) => (
            <li
              key={`custom_macros_${index}`}
              className="messages-li"
              uk-tooltip="Click to Insert Macro"
              onClick={() => {
                if (onMacroClick) onMacroClick(macros.macro);
                if (window.UIkit) {
                  document.querySelectorAll('#macros-reservation').forEach(el => {
                    window.UIkit.dropdown(el).hide();
                  });
                }
              }}
              style={{ cursor: "pointer" }}
              tabIndex={0}
            >
              <div>{macros.macro}</div>
              <div uk-line-clamp="lines: 1">{macros.label}</div>
            </li>
          ))}
          <div className="uk-form-label uk-margin-top uk-margin-tiny-bottom uk-margin-small-left">
            Survey Macros
          </div>
          {allSurveys?.map((survey, index) => (
            <li
              key={`survey_${index}`}
              className="messages-li"
              uk-tooltip="Click to Insert Macro"
              onClick={() => {
                if (onMacroClick) onMacroClick(`[Survey-${survey.survey_id}]`);
                if (window.UIkit) {
                  document.querySelectorAll('#macros-reservation').forEach(el => {
                    window.UIkit.dropdown(el).hide();
                  });
                }
              }}
              style={{ cursor: "pointer" }}
              tabIndex={0}
            >
              <span className="macro-value">{`[Survey-${survey.survey_id}]`}</span>
              <span>
                {survey.name?.length > 30
                  ? `${survey.name.slice(0, 30)}...`
                  : survey.name}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default MacrosReservationKeys;
